import {
    SHOW_INDICES_POPUP,
    HIDE_INDICES_POPUP,
    ALL_INDICES_REQUEST,
    ALL_INDICES_SUCCESS,
    ALL_INDICES_FAIL,
    INDEX_SETTLEMENT_REQUEST,
    INDEX_SETTLEMENT_SUCCESS,
    INDEX_SETTLEMENT_FAIL,
    GET_SCHEDULE_REQUEST,
    GET_SCHEDULE_SUCCESS,
    GET_SCHEDULE_FAIL,
    SET_SELECTED_DATE,
    SET_SCHEDULE_UPDATED,
    INDICES_MARKETS_LIST_REQUEST,
    INDICES_MARKETS_LIST_SUCCESS,
    INDICES_MARKETS_LIST_FAIL,
    SET_MARKET_ID,
    SET_INDICES_YEAR,
    SET_SELECTED_FREQUENCY_TYPE,
    SET_INDICES_MODAL_SETTING,
} from '../constants/action-types';
import { IndicesFrequency } from '../constants/indices';

const initialState = {
    fetching: false,
    inicesPopupVisible: false,
    indicesShedule: {
        [IndicesFrequency.DAILY]: {},
        [IndicesFrequency.WEEKLY]: {},
    },
    data: {},
    frequencyType: IndicesFrequency.DAILY,
    selected_date: '',
    scheludeUpdated: false,
    marketsList: [],
    market_id: '',
    year: null,
};

export default function indices(state = initialState, action) {
    switch (action.type) {
        case INDICES_MARKETS_LIST_SUCCESS:
            return {
                ...state,
                marketsList: action.payload,
            };
        case SHOW_INDICES_POPUP:
            return {
                ...state,
                inicesPopupVisible: true,
            };
        case HIDE_INDICES_POPUP:
            return {
                ...state,
                inicesPopupVisible: false,
            };
        case ALL_INDICES_REQUEST:
            return {
                ...state,
                fetching: true,
            };
        case ALL_INDICES_SUCCESS:
            return {
                ...state,
                fetching: false,
                data: action.payload,
            };
        case ALL_INDICES_FAIL:
            return {
                ...initialState,
                fetching: false,
            };
        case INDEX_SETTLEMENT_REQUEST:
            return {
                ...state,
                fetching: true,
            };
        case INDEX_SETTLEMENT_SUCCESS:
            return {
                ...state,
                fetching: false,
            };
        case INDEX_SETTLEMENT_FAIL:
            return {
                ...state,
                fetching: false,
            };
        case GET_SCHEDULE_REQUEST:
            return {
                ...state,
                fetching: true,
            };
        case GET_SCHEDULE_SUCCESS:
            return {
                ...state,
                fetching: false,
                indicesShedule: action.payload,
            };
        case GET_SCHEDULE_FAIL:
            return {
                ...state,
                fetching: false,
            };
        case SET_SELECTED_DATE:
            return {
                ...state,
                selected_date: action.selected_date,
            };
        case SET_SCHEDULE_UPDATED:
            return {
                ...state,
                scheludeUpdated: action.value,
            };
        case SET_MARKET_ID:
            return {
                ...state,
                market_id: action.market_id,
            };
        case SET_INDICES_YEAR:
            return {
                ...state,
                year: action.year,
            };
        case SET_SELECTED_FREQUENCY_TYPE:
            return {
                ...state,
                frequencyType: action.frequencyType,
            };
        case SET_INDICES_MODAL_SETTING:
            return {
                ...state,
                ...action.payload,
            };
        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./source/reducers/indices.js